
<template>
 <div class="container globalMargin">
   <h1 class="title_name">对账管理</h1>
  <div class="home">
    

  

  <!-- <div class="dilinkTabs">
    <el-tabs type="card" >
      <el-tab-pane v-for="(item,i) in contentList" v-model="childrenId" :key="i" @tab-click="childrenId=i">
        <span slot="label">{{item}}</span>
      </el-tab-pane>
    </el-tabs>
  </div> -->
    <el-button type="primary" size="small" icon="el-icon-back" class="fr" @click="back">返回</el-button>
    <div class="tags">
      <div @click="childrenId=i" :class="{active:i === childrenId}" 
      v-for="(item,i) in contentList" :key="i" class="subTag">{{item}}</div>
    </div>
    
     <div class="line"></div>
    <Rectangle :path="require('@/assets/img/common/rectangle.png')" style="margin:15px 0" :name="'信息列表'"/>
     <component
         style="width: 100%;"
         v-show="!showFlag"
         :is="componentsObj[childrenId]"
         :contentList="contentList"
         :page="page"
       ></component>
    </div>
  </div>
</template>

<script>
import platform from './checkManageMentDetailPlatform.vue'
import sort from './checkManageMentDetailSort.vue'
import Rectangle from '@/components/public/Element/rectangle.vue'

  export default {
    components:{
      platform,
      sort,
      Rectangle
    },
    data() {
      return {
        componentsObj: {
          0:'platform',
          1:'sort',
        },
        contentid:'',
        childrenId:0,
        showFlag: 0,
        contentList:['平台','清分银行'],
        page: {
        total: 6,
        currentPage: 1,
        size: 6,
      },
        multipleSelection: []
      }
    },
    showDetail(index, i) {
      this.showFlag = index;
      this.contentid = i;
    },
    methods: {
    onSubmit() {
      console.log('submit!');
    },
    back(){
      this.$router.back(-1)
    },
    toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
    handleSelectionChange(val) {
        this.multipleSelection = val;
      }
   }
  }
  
</script>

<style lang="less" scoped>

.home {

  background-color: var(--color-background);
}



.tags {
  display: flex;
  // margin-left: 41px;
  font-family: MicrosoftYaHei;

  .subTag {
    padding: 0 20px;
    height: 36px;
    line-height: 36px;
    margin-right: 21px;
    text-align: center;
    color: var(--color-text);
    font-size: 14px;
    cursor: pointer;
  }
  .active {
    background: #EBF0FA;
    color: #1B5BBF;
    border-radius: 2px;
    border: 1px solid #D5DBE8;
  }
}

.line {
  margin:0;
  background-color: #d5dbe8;
  height: 1px;
  border-top:1px solid #dedbe8;
}
</style>
